import { render } from "./tableMenus.vue?vue&type=template&id=b3c0c494&scoped=true"
import script from "./tableMenus.vue?vue&type=script&lang=js"
export * from "./tableMenus.vue?vue&type=script&lang=js"

import "./tableMenus.vue?vue&type=style&index=0&id=b3c0c494&lang=less&scoped=true"

import exportComponent from "D:\\wkb\\dev\\study\\盘雷\\lida-web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b3c0c494"]])

export default __exports__